export interface ISelectedTags {
    colorElements: {
        color: string;
        entity_id: number;
    }[];
    ids: number[];
    model: any;
}

export interface PBIDefaultState {
    referencePBI: number | null;
    selectedTags: Record<number, ISelectedTags[]>;
    isolatedTags: Record<number, ISelectedTags[]>;
    coloredTags: Record<number, ISelectedTags[]>;
    pushpinTags: Record<number, ISelectedTags[]>;
}

const SET_REFERENCE_PBI = "SET_REFERENCE_PBI";
const SET_SELECTED_TAGS_PBI = "SET_SELECTED_TAGS_PBI";
const SET_ISOLATED_TAGS_PBI = "SET_ISOLATED_TAGS_PBI";
const SET_COLORED_TAGS_PBI = "SET_COLORED_TAGS_PBI";
const SET_PUSHPIN_TAGS_PBI = "SET_PUSHPIN_TAGS_PBI";
const RESET_PBI_STATE = "RESET_PBI_STATE";


const initialState: PBIDefaultState = {
    referencePBI: null,
    selectedTags: {},
    isolatedTags: {},
    coloredTags: {},
    pushpinTags: {}
};

interface SetPbiRefrence {
    type: typeof SET_REFERENCE_PBI;
    payload: PBIDefaultState;
}

interface SetPbiSelectedTags {
    type: typeof SET_SELECTED_TAGS_PBI;
    payload: {
        pbiId: number,
        selectedTags: ISelectedTags[]
    };
}

interface SetPbiIsolatedTags {
    type: typeof SET_ISOLATED_TAGS_PBI;
    payload: {
        pbiId: number,
        isolatedTags: ISelectedTags[]
    };
}

interface SetPbiColoredTags {
    type: typeof SET_COLORED_TAGS_PBI;
    payload: {
        pbiId: number,
        coloredTags: ISelectedTags[]
    };
}

interface SetPbiPushpinTags {
    type: typeof SET_PUSHPIN_TAGS_PBI;
    payload: {
        pbiId: number,
        pushpinTags: ISelectedTags[]
    };
}

interface ResetPbiState {
    type: typeof RESET_PBI_STATE;
}

export type PbiStateType =
    | SetPbiRefrence
    | SetPbiSelectedTags
    | SetPbiIsolatedTags
    | SetPbiColoredTags
    | SetPbiPushpinTags
    | ResetPbiState;


export function pbiReducer(
    state = initialState,
    action: PbiStateType
): PBIDefaultState {
    if (action.type === RESET_PBI_STATE) {
        return {
            referencePBI: null,
            selectedTags: {},
            isolatedTags: {},
            coloredTags: {},
            pushpinTags: {}
        };
    }
    if (action.type === SET_REFERENCE_PBI) {
        return {
            ...state,
            referencePBI: action.payload.referencePBI,
        };
    }
    if (action.type === SET_SELECTED_TAGS_PBI) {
        return {
            ...state,
            selectedTags: {
                ...state.selectedTags,
                [action.payload.pbiId]: action.payload.selectedTags
            }
        };
    }
    if (action.type === SET_ISOLATED_TAGS_PBI) {
        return {
            ...state,
            isolatedTags: {
                ...state.isolatedTags,
                [action.payload.pbiId]: action.payload.isolatedTags
            }
        };
    }
    if (action.type === SET_COLORED_TAGS_PBI) {
        return {
            ...state,
            coloredTags: {
                ...state.coloredTags,
                [action.payload.pbiId]: action.payload.coloredTags
            }
        };
    }
    if (action.type === SET_PUSHPIN_TAGS_PBI) {
        return {
            ...state,
            pushpinTags: {
                ...state.pushpinTags,
                [action.payload.pbiId]: action.payload.pushpinTags
            }
        };
    }
    return state;
}

export const setReferencePBI = (pbiId: number | null) => {
    return {
        type: SET_REFERENCE_PBI,
        payload: {
            referencePBI: pbiId
        }
    }
}

export const resetPBIState = () => {
    return {
        type: RESET_PBI_STATE
    };
};


export const setSelectedTag = (
    pbiId: number,
    selectedTags: ISelectedTags[]
) => {
    return {
        type: SET_SELECTED_TAGS_PBI,
        payload: {
            pbiId,
            selectedTags
        }
    };
};

export const setIsolatedTag = (
    pbiId: number,
    isolatedTags: ISelectedTags[]
) => {
    return {
        type: SET_ISOLATED_TAGS_PBI,
        payload: {
            pbiId,
            isolatedTags
        }
    };
};

export const setColoredTag = (
    pbiId: number,
    coloredTags: ISelectedTags[]
) => {
    return {
        type: SET_COLORED_TAGS_PBI,
        payload: {
            pbiId,
            coloredTags
        }
    };
};

export const setPushpinTag = (
    pbiId: number,
    pushpinTags: ISelectedTags[]
) => {
    return {
        type: SET_PUSHPIN_TAGS_PBI,
        payload: {
            pbiId,
            pushpinTags
        }
    };
};